import React from 'react';
import { COLORS } from '../../../core/constants/colors';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  disabled = false,
  fullWidth = true,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${fullWidth ? 'w-full' : ''} py-3 px-6 rounded-lg font-semibold transition-all hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed`}
      style={{
        backgroundColor: variant === 'primary' ? COLORS.user.primary : COLORS.extended.cultured,
        color: variant === 'primary' ? '#FFFFFF' : COLORS.primary.persianIndigo,
      }}
    >
      {children}
    </button>
  );
};